// This is all you.
import('./dropdown');
import('./image-detail');
import('./program-nav');
import('./promo-boxes');
import { Fancybox } from '@fancyapps/ui';

import './alpine';
import './navbar';


Fancybox.bind('[data-fancybox]', {
  //
});
